import React from "react";
import { AppBar, Toolbar, Box, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import imagelogo from "../../Images/imagelogo-removebg-preview(1).png";

// Icons
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";

const navLinks = [
  { label: "Trekking Tours", path: "/trekkingtours" },
  { label: "Tour Packages", path: "/tourpackages" },
  { label: "Motorcycle Tours", path: "/motorcylestours" },
  { label: "Self Drive 4x4", path: "/selfdrive" },
  { label: "About Us", path: "/contactuss" }
];

const NavbarDesktop = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <TopBar />

      <AppBar
        position="sticky"
        elevation={1}
        sx={{
          bgcolor: "#fff",
          top: 0,
          zIndex: 1200 // ✅ never hides on scroll
        }}
      >
        <Toolbar
          sx={{
            maxWidth: "1400px",
            mx: "auto",
            width: "100%",
            minHeight: 90,
            px: 3,
            position: "relative"
          }}
        >
          {/* ================= LEFT MENU ================= */}
          <Box
            sx={{
              display: "flex",
              gap: 3,
              alignItems: "center",
              whiteSpace: "nowrap"
            }}
          >
            {navLinks.map((item) => (
              <Box
                key={item.path}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  color: isActive(item.path) ? "#065f46" : "#374151",
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -6,
                    width: isActive(item.path) ? "100%" : 0,
                    height: "2px",
                    background: "#10b981",
                    transition: "0.3s"
                  },
                  "&:hover::after": {
                    width: "100%"
                  }
                }}
              >
                {item.label}
              </Box>
            ))}
          </Box>

          {/* ================= CENTER LOGO (TRUE CENTER) ================= */}
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              top:'-55%',
              transform: "translateX(-50%)",
              cursor: "pointer"
            }}
            onClick={() => navigate("/")}
          >
            <img
              src={imagelogo}
              alt="Logo"
              style={{
                height: 105,
                objectFit: "contain"
              }}
            />
          </Box>

          {/* ================= RIGHT SOCIAL + CTA ================= */}
          <Box
            sx={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: 2
            }}
          >
            <InstagramIcon
              sx={{
                cursor: "pointer",
                color: "#E1306C",
                transition: "0.3s",
                "&:hover": { transform: "scale(1.15)" }
              }}
              onClick={() => window.open("https://instagram.com", "_blank")}
            />

            <FacebookIcon
              sx={{
                cursor: "pointer",
                color: "#1877F2",
                transition: "0.3s",
                "&:hover": { transform: "scale(1.15)" }
              }}
              onClick={() => window.open("https://facebook.com", "_blank")}
            />

            <YouTubeIcon
              sx={{
                cursor: "pointer",
                color: "#FF0000",
                transition: "0.3s",
                "&:hover": { transform: "scale(1.15)" }
              }}
              onClick={() => window.open("https://youtube.com", "_blank")}
            />

            <Button
              onClick={() => navigate("/booking")}
              sx={{
                ml: 1,
                background: "#065f46",
                color: "#fff",
                px: 3.5,
                py: 1,
                borderRadius: "999px",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  background: "#10b981"
                }
              }}
            >
              Book Now
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NavbarDesktop;
